import React, { ReactNode } from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLLabelElement> {
  className?: string
  children: ReactNode
}

const Label: React.FC<InputProps> = ({ className, children, ...props }) => {
  return (
    <label className={`block text-foreground text-sm font-medium mb-2 ${className || ''}`}
      {...props}
    >{children}
    </label>
  )
}

export default Label